import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import "./CustomerForm.css";


function StoreSelector({ value, onChange }) {
  const [stores, setStores] = useState([]);
  const [open, setOpen] = useState(false);
  const [tapCount, setTapCount] = useState(0);

  // fetch stores
  useEffect(() => {
    fetch("https://test.hamarachoiceschemes.com/api/store/")
      .then((res) => res.json())
      .then((data) => {
        setStores(data);
        if (!value && data.length) {
          onChange(data[0]); // default
        }
      });
  }, []);

  // triple tap handler
  const handleTap = () => {
    setTapCount((prev) => {
      const next = prev + 1;
      if (next === 2) {
        setOpen(true);
        return 0;
      }
      setTimeout(() => setTapCount(0), 600);
      return next;
    });
  };

  return (
    <>
      {/* Display text */}
      <Box
        onClick={handleTap}
        sx={{
          textAlign: "center",
          mt: 2,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <Typography className="store-text-head">
          <p className="store-text">Store: {value?.name || "Not Selected"}</p>
        </Typography>
      </Box>

        {/* Popup */}
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            className="store-container"
            slots={{ paper: 'div' }} // Use a custom wrapper
            slotProps={{
                paper: {
                    className: "store-dialog-paper",
                },
            }}
        >
            <DialogTitle>
                <div className="store-title">
                    Select Store
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="store-grid">
                    {stores.map((store) => {
                    const isSelected = value?.id === store.id;

                    return (
                        <div
                        key={store.id}
                        className={`store-card ${isSelected ? "selected" : ""}`}
                        onClick={() => {
                            onChange(store);
                            setOpen(false);
                        }}
                        >
                        <div className="store-name">{store.name}</div>
                        </div>
                    );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    </>
  );
}

export default StoreSelector;
